<template>
  <main class="public-leagues">
    <section>
      <ims-item class="divider">My Leagues</ims-item>
      <ims-item v-for="(league, index) in myLeagues" :key="index">
        <h1>{{ league.name }}</h1>
        <template v-slot:right>
          <ims-button type="clear" color="red" @click="leaveLeague(league)">Leave</ims-button>
        </template>
      </ims-item>
    </section>
    <section>
      <ims-item class="divider">Public Leagues</ims-item>
      <ims-item v-for="(league, index) in availableLeagues" :key="index">
        <h1>{{ league.name }}</h1>
        <template v-slot:right>
          <ims-button type="clear" color="primary" @click="joinLeague(league)">Join</ims-button>
        </template>
      </ims-item>
    </section>
    <ims-item class="divider" />
  </main>
</template>

<script>
/**
 * DEPRECATED
 */
export default {
  computed: {
    myLeagues() {
      return this.$store.state.leagues.mine;
    },
    leagues() {
      return this.$store.state.leagues.public;
    },
    availableLeagues() {
      return this.$store.getters['leagues/available'];
    }
  },
  mounted() {
    // this.$store.dispatch("leagues/public/load");
    // if (!this.$store.state.leagues.mine) {
    //   this.$store.dispatch("leagues/mine/load");
    // }
  },
  methods: {
    joinLeague(league) {
      this.$store.dispatch('leagues/public/join', league);
    },
    leaveLeague(league) {
      const self = this;
      this.$store.dispatch('interact/popmenu', {
        title: 'Are you sure you want to leave this league?',
        buttons: [
          {
            title: 'Leave League',
            click() {
              // self.$store.dispatch('leagues/leave', league);
            }
          }
        ]
      });
    }
  }
};
</script>